import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
export const useDrag = ({ ref, parent }) => {
  const checkInitPos=(evt)=>{
    var { left, top ,width,height} = parent.getBoundingClientRect()
    const { current: draggableElement } = ref;
    const dragEl = draggableElement.getBoundingClientRect()
    const { clientX, clientY } = evt;
    const position = {
      x:(clientX - left) * (1 / Global.currentScale),
      y:(clientY - top) * (1 / Global.currentScale)
    }
    left = left * (1 / Global.currentScale)
    top = top * (1 / Global.currentScale)
    width = width * (1 / Global.currentScale)
    height = height * (1 / Global.currentScale)
    dragEl.width = dragEl.width  * (1 / Global.currentScale) 
    dragEl.height = dragEl.height * (1 / Global.currentScale)
    // console.log(position.x + dragEl.width,position.y + dragEl.height)
    // console.log(position)
    var outside = false;
    if(position.x + dragEl.width < dragEl.width) {position.x = 0 ;outside=true}
    if(position.y + dragEl.height < dragEl.height) {position.y = 0 ;outside=true}
    if(position.x + dragEl.width > width ) {position.x = width - dragEl.width;outside=true}
    if(position.y + dragEl.height > height ){ position.y = height - dragEl.height;outside=true}
    return [position,outside]
  }
  const currentState = useSelector((state) => state.current)
  const noteState = useSelector(state => state.note)
  const [finalPosition, setFinalPosition] = useState();
  const [isDragging, setIsDragging] = useState(false);
  const handleMouseUp = (evt) => {
    // evt.preventDefault();
    
    setIsDragging(false);
    currentState.canvasObj.containerEl.parentNode.classList.remove("opr-hidecursor");
    if(!currentState.focmode) currentState.canvasObj.containerEl.parentNode.classList.add(currentState.selecteditem)
  };

  const handleMouseDown = (evt) => {
    // evt.preventDefault();
    setIsDragging(true);
    currentState.canvasObj.containerEl.parentNode.classList.remove(currentState.selecteditem);
    currentState.canvasObj.containerEl.parentNode.classList.add("opr-hidecursor");
  };

  const handleMouseMove = useCallback(
    (evt) => {
      const { current: draggableElement } = ref;
      if (!isDragging || !draggableElement) return;
      // evt.preventDefault();
      var { left, top ,width,height} = parent.getBoundingClientRect()
      const dragEl = draggableElement.getBoundingClientRect()
      const { clientX, clientY } = evt;
      const position = {
        x:(clientX - left) * (1 / Global.currentScale) - (dragEl.width* (1 / Global.currentScale))/2,
        y:(clientY - top) * (1 / Global.currentScale) - (dragEl.height* (1 / Global.currentScale))/2
      }
      left = left * (1 / Global.currentScale)
      top = top * (1 / Global.currentScale)
      width = width * (1 / Global.currentScale)
      height = height * (1 / Global.currentScale)
      dragEl.width = dragEl.width * (1 / Global.currentScale)
      dragEl.height = dragEl.height * (1 / Global.currentScale)
      if(position.x + dragEl.width < dragEl.width) position.x = 0 
      if(position.y + dragEl.height < dragEl.height) position.y = 0 
      if(position.x + dragEl.width > width ) position.x = width - dragEl.width
      if(position.y + dragEl.height > height ) position.y = height - dragEl.height
      
      setFinalPosition(position);
    },
    [isDragging, ref]
  );

  useEffect(() => {
    parent.addEventListener("mousemove", handleMouseMove);
    parent.addEventListener("mouseup", handleMouseUp);
    return () => {
      parent.removeEventListener("mousemove", handleMouseMove);
      parent.removeEventListener("mouseup", handleMouseUp);
    };
  }, [handleMouseMove]);
  return {
    position: finalPosition,
    handleMouseDown,
    checkInitPos,handleMouseUp,setFinalPosition
  };
};
